// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__39QLp","col":"styles_col__25aIz"};